// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"250":"f530e8eb293a2d5d3916","351":"0320ebbd5f2bc37a1b5e","666":"8db26a3ae78fee0b0e3f","691":"a447e17e3276e459a0ad","774":"f5b4169af05c524f6983"}[chunkId] + ".js";
};